export default "__VITE_ASSET__f6fe1581__"